import type {SupportedCountries} from '@/lib/locale/country'
import simpleStorage from '@/utils/simpleStorage'

import {FoodCartV1, getDefaultFoodCart} from './foodModel'

export const FOOD_CART_KEY = `guest-food-cart`

function getFoodCartKey(country: SupportedCountries) {
  return `${FOOD_CART_KEY}-${country}`
}

function getFoodCart(country: SupportedCountries): FoodCartV1 {
  try {
    return FoodCartV1(simpleStorage.get(getFoodCartKey(country)))
  } catch {
    return getDefaultFoodCart()
  }
}

function updateFoodCart({country, foodCart}: {country: SupportedCountries; foodCart: FoodCartV1}) {
  simpleStorage.set(getFoodCartKey(country), foodCart)
  return foodCart
}

function clearFoodCart(country: SupportedCountries) {
  simpleStorage.remove(getFoodCartKey(country))
}

export default {getFoodCart, updateFoodCart, clearFoodCart}
